import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Divider,
  Box,
} from '@mui/material';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Delete',
  message = 'Are you sure you want to delete this record?',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      {/* Header */}
      <DialogTitle id="delete-dialog-title" sx={{ backgroundColor: '#1e2a38', color: 'white', fontWeight: 'bold', p: 1 }}>
        {title}
      </DialogTitle>

      {/* Separator */}
      <Divider />

      {/* Content */}
      <DialogContent sx={{ backgroundColor: '#fefefe' }}>
        <DialogContentText id="delete-dialog-description" sx={{ fontSize: '16px' }}>
          {message}
        </DialogContentText>
      </DialogContent>

      {/* Footer */}
      <Box sx={{ backgroundColor: '#f5f5f5', p: 0 }}>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={onConfirm} color="error">
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
